import { lazy, useEffect, useState } from 'react'
import { KeycloakAdminService } from '@nv/auth'
import { NVButton } from '@nv/basic-components'
import { Attachments, useNVModal } from '@nv/components'
import { useConfigurationContext } from '@nv/contexts'
import FileIcon from '@nv/images/design/file-icon'
import { AdminVoterAuthService } from '@nv/services'
import { VoterAuthService } from '@nv/services'
import { isViewOnlyHelpManagement } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import styles from './HelpAndSupport.module.scss'
const EventAttach = lazy(() => import('@nv/lazy-loadable/lib/modals/EventAttach'))
const ContactUsInfo = lazy(() => import('@nv/lazy-loadable/lib/modals/ContactUsInfo'))

export const HelpAndSupport = () => {
  const { t } = useTranslation()
  const [currentView] = useState('Add Document')
  const [listOfDocs, setListOfDocs] = useState([] as any)
  const { contactInfoHelpSupport } = useConfigurationContext()
  const { NVModal: UploadDocModal, openModal: openuploadDocModal } = useNVModal()
  const { NVModal: ContactUsModal, openModal: openContactUsModal } = useNVModal()

  const isAdmin = KeycloakAdminService?.isLoggedIn()
  const viewOnly = isViewOnlyHelpManagement()

  const getHelpDocs = async () => {
    try {
      let resp
      if (isAdmin) resp = await AdminVoterAuthService.getHelpDocs()
      else resp = await VoterAuthService.getHelpDocs()
      if (resp) setListOfDocs(resp)
    } catch (error) {
      //console.log(error)
    }
  }

  const onSubmitUpload = async (formData, eventId = null) => {
    return await AdminVoterAuthService.createHelpDoc(formData)
  }

  useEffect(() => {
    getHelpDocs()
  }, [])

  return (
    <>
      <UploadDocModal>
        <EventAttach view={currentView} eventId={null} getAttachments={getHelpDocs} onSubmitUpload={onSubmitUpload} />
      </UploadDocModal>

      <ContactUsModal>
        <ContactUsInfo />
      </ContactUsModal>

      <div className={styles['container']}>
        <div className={styles['header']}>
          <h1>{t('pages.helpAndSupport')}</h1>

          {!isViewOnlyHelpManagement() && (
            <NVButton
              variant='primaryGrey'
              text={t('uploads.document.add')}
              height={40}
              onClick={() => openuploadDocModal()}
              icon={<FileIcon color={'var(--primary-color)'} />}
            />
          )}

          {contactInfoHelpSupport && isViewOnlyHelpManagement() && (
            <NVButton variant='primaryGrey' text={t('auth.help.contactUs')} height={40} onClick={() => openContactUsModal()} />
          )}
        </div>

        <Attachments listOfDocs={listOfDocs} getAttachments={getHelpDocs} viewOnly={viewOnly} />
      </div>
    </>
  )
}
